import React from 'react'
import Axios from 'axios'
import { FcCheckmark } from 'react-icons/fc'
import { IoIosCheckmarkCircleOutline, IoIosArrowRoundForward } from 'react-icons/io'
import ReactAudioPlayer from 'react-audio-player'
import { Link, NavLink } from 'react-router-dom'
import { API_URL } from './config'

class Success extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      url: '',
    }
  }
  componentDidMount() {
    const query = new URLSearchParams(this.props.location.search)

    const email = query.get('email')
    const ticketnumber = query.get('ticketnumber')
    const ticketid = query.get('ticketid')
    const eventid = query.get('eventid')
    const businessid = query.get('businessid')
    const category = query.get('category')
    const phone = query.get('phone')
    const total = query.get('total')
    const admission = query.get('admission')
    const group = query.get('group')
    const price = query.get('price')
    const kids_price = query.get('kids_price')
  }

  render() {
    window.onbeforeunload = function () {
      return false
    }
    function my_onkeydown_handler(event) {
      switch (event.keyCode) {
        case 116: // 'F5'
          event.preventDefault()
          break

        case 17: // 'Ctrl'
          event.preventDefault()
          break

        case 82: // 'R'
          event.preventDefault()
          break
      }
    }
    document.addEventListener('keydown', my_onkeydown_handler)
    return (
      <div className="row background-img">
        <div className="w-100 pl-5 pr-5 shield">
          <div className="success-response">
            <div className="row h-100 justify-content-center">
              <div className="align-self-center text-center">
                <div className="sub-text-success-message">
                  <div style={{ display: 'none' }}>
                    <ReactAudioPlayer
                      src={`${API_URL}/apps/kscanner/success.mp3`}
                      autoPlay={true}
                      controls
                    />
                  </div>

                  <div class="message-box">
                    <IoIosCheckmarkCircleOutline size={40} />
                    <h1 style={{ color: '#000', marginTop: 15 }}>Payment Successful</h1>
                    <p>Thank you! Your payment has been processed successfully.</p>
                    <Link
                      to={localStorage.getItem('businessid') ? '/dashboard' : '/tickets'}
                      className="new-account-btn text-white"
                    >
                      {localStorage.getItem('businessid') ? (
                        <span>Dashboard</span>
                      ) : (
                        <span>Go to your ticket </span>
                      )}{' '}
                      <IoIosArrowRoundForward size={25} />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Success
